<template>
  <Header />
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <Wellcome />
      <Banner />
      <CardsList />
    </div>
  </div>
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Wellcome from "@/components/Wellcome.vue";
import Banner from "@/components/Banner.vue";
import CardsList from "@/components/CardsList.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Wellcome,
    Banner,
    CardsList,
    Footer,
  },
};
</script>

<style lang="scss" module>
// .wrapper {
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
// }
.container {
  max-width: 78.75rem;
  margin: 0 auto 2rem auto;
}
</style>
